const stages = [
  {
    number: '01',
    title: 'Подготовка рабочего места',
    duration: 'За 3-5 дней до выхода',
    items: [
      'Настроить компьютер, учётные записи, доступы к системам',
      'Подготовить welcome-пакет: блокнот, ручка, мерч компании',
      'Назначить наставника и согласовать его график',
      'Оповестить команду о выходе нового сотрудника',
      'Подготовить чек-лист первой недели',
    ],
  },
  {
    number: '02',
    title: 'Первый рабочий день',
    duration: 'День 1',
    items: [
      'Встреча с руководителем: цели, ожидания, роль в команде',
      'Знакомство с командой и наставником',
      'Экскурсия по офису: где что находится',
      'Базовый инструктаж по технике безопасности (если требуется)',
      'Настройка рабочих инструментов и знакомство с регламентами',
    ],
  },
  {
    number: '03',
    title: 'Первая неделя',
    duration: 'Дни 2-7',
    items: [
      'Погружение в продукт, услуги и клиентов компании',
      'Знакомство с процессами и стандартами работы',
      'Первые задачи под наблюдением наставника',
      'Ежедневные короткие встречи с руководителем',
      'Заполнение чек-листа первой недели',
    ],
  },
  {
    number: '04',
    title: 'Первый месяц',
    duration: 'Недели 2-4',
    items: [
      'Самостоятельное выполнение задач с поддержкой наставника',
      'Изучение базы знаний, регламентов и книги продаж',
      'Участие в командных встречах и планерках',
      'Первая промежуточная оценка: что идёт хорошо, что улучшить',
      'Корректировка плана адаптации по результатам оценки',
    ],
  },
  {
    number: '05',
    title: 'Испытательный срок',
    duration: 'Месяцы 2-3',
    items: [
      'Выход на плановые KPI и самостоятельную работу',
      'Регулярные встречи с руководителем раз в 2 недели',
      'Промежуточная оценка в середине и конце срока',
      'Корректировка целей и плана развития',
      'Принятие решения о прохождении испытательного срока',
    ],
  },
  {
    number: '06',
    title: 'Полноценная интеграция',
    duration: 'От 3 месяцев',
    items: [
      'Финальная оценка эффективности адаптации',
      'Включение в долгосрочные проекты и инициативы',
      'Составление индивидуального плана развития на год',
      'Привлечение к наставничеству будущих новичков',
      'Полноценное участие в жизни команды и корпоративной культуре',
    ],
  },
];

export default function OnboardingStages() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Этапы эффективной адаптации сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Системный онбординг — это 6 последовательных этапов. Каждый решает свою задачу и готовит сотрудника к следующему уровню самостоятельности.
        </p>

        <div className="space-y-6">
          {stages.map((stage, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200 flex flex-col md:flex-row gap-6 items-start">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-2xl">{stage.number}</span>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-4">
                  <h3 className="text-2xl font-bold text-gray-900">{stage.title}</h3>
                  <span className="text-sm bg-teal-100 text-teal-700 px-3 py-1 rounded-full whitespace-nowrap inline-block w-fit">{stage.duration}</span>
                </div>
                <ul className="space-y-2">
                  {stage.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-gray-700">
                      <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm md:text-base leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}